import { Dispatch, MouseEventHandler, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

// local imports
import useListActions from './use-list-actions'
import { IFavoriteCampusServices, TCampusServiceType } from 'types/FavoritesType'
import FavoriteIconButton from 'components/ui/FavoriteIconButton'
import { ListActionArea, ListItem, ReservationButton } from '../styled'
/* Assets */
import doctor from 'assets/icons/doctor.svg'
import gym from 'assets/icons/gym.svg'
import coiffeur from 'assets/icons/hairdresser.svg'
import lactation from 'assets/icons/baby.svg'
import park from 'assets/icons/park-area.svg'
import meeting from 'assets/icons/meeting-room.svg'

const icons = { 1: doctor, 2: coiffeur, 3: gym, 4: lactation, 5: park, 6: meeting }
interface ListItemProps {
  setList: Dispatch<SetStateAction<[] | IFavoriteCampusServices[]>>
  item: IFavoriteCampusServices
  setReservationType: (
    type: TCampusServiceType | 0,
    item: IFavoriteCampusServices | undefined
  ) => MouseEventHandler<HTMLButtonElement> | undefined
}

const subTypes = { 0: '', 1: 'personal', 2: 'trainer', 3: 'group-lesson' }

export default function FavoriteListItem({ item, setList, setReservationType }: ListItemProps) {
  const { t } = useTranslation()
  const locationAddress = `${item?.floor?.cityName}/${item?.floor?.districtName} ${item?.floor?.countryName}, ${item?.floor?.locationName}`
  const subType = item?.campusServiceSubType

  /* Actions Hook (remove favorite - set reservation) */
  const { handleRemoveFavorite } = useListActions(setList)
  const subTypeName = `dashboard.on-campus-tabs.${subTypes[subType]}`

  return (
    <ListItem>
      <div className="fav-icon">
        <img src={icons[item.campusServiceType]} width={24} height={24} alt="favorite-list-icon" />
      </div>

      <div className="fav-content">
        <div className="fav-name-loc">
          <span className="fav-name">{item.name || '---'}</span>
          <span className="fav-location">{locationAddress}</span>
        </div>
        <div className="fav-block"> {item?.floor?.blockName || '---'} </div>
        <div className="fav-floor"> {item?.floor?.name} </div>
        <div className="fav-detail">
          {subType !== 0 ? `${t(subTypeName)} ${!!item?.branch ? '| ' : ''}` : null} {item?.branch || ''}
        </div>
      </div>

      <ListActionArea>
        <ReservationButton onClick={setReservationType(item.campusServiceType, item)}>
          {t('buttons.book-reservation')}
        </ReservationButton>
        <FavoriteIconButton
          isFavorite
          onRemove={handleRemoveFavorite(item.campusServiceType, item.campusServiceSubType, item.id)}
        />
      </ListActionArea>
    </ListItem>
  )
}
